function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4.75,
  y: 10.1785,
  width: 14.5,
  height: 11.5,
  rx: 1.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1052 9.57095V6.67418C16.1052 4.46504 14.3144 2.67418 12.1052 2.67418V2.67418C9.89609 2.67418 8.10522 4.46504 8.10522 6.67418V9.57095",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgLock = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Lock.5727db56.svg";
export { ForwardRef as ReactComponent };